import { apiPost, notifySuccess } from "@redriver/cinnamon";

const ActionTypes = {
  SendToSupplier: "SHEETS/SEND_TO_SUPPLIER",
};

export const sendToSupplier = ({ sheetId }) =>
  apiPost(ActionTypes.SendToSupplier, `sheets/${sheetId}/send-to-supplier`);
